import { useState } from 'react';
import { AritoDialog, AritoForm, AritoIcon } from '@/components/custom/arito';
import { useAuth } from '@/contexts/auth-context';
import { Button } from '@/components/ui/button';
import { useTable } from './table/useTable';
import DetailTab from './table';

interface BulkDeleteDialogProps {
  title: string;
  onClose: () => void;
  columns?: any[];
  dataRows?: any[];
  handleDelete: (uuids: string[]) => void;
}

const BulkDeleteDialogV2 = ({ title, onClose, columns, dataRows, handleDelete }: BulkDeleteDialogProps) => {
  const [selectedDetailRowIds, setSelectedDetailRowIds] = useState<string[]>([]);
  const { rows: detailRows, selectedRowUuid: detailSelectedRowUuid, setRows } = useTable(dataRows || []);
  const { setLoading } = useAuth();

  const handleBulkDelete = async () => {
    try {
      setLoading(true);
      await handleDelete(selectedDetailRowIds);

      setRows(prevRows => prevRows.filter(row => !selectedDetailRowIds.includes(row.uuid || '')));
      setSelectedDetailRowIds([]);
    } catch (error) {
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <AritoDialog
      open={true}
      onClose={onClose}
      title={title}
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={279} />}
    >
      <AritoForm
        mode='view'
        hasAritoActionBar={false}
        className='w-[60vw] min-w-[900px]'
        headerFields={
          <DetailTab
            rows={detailRows}
            selectedRowUuid={detailSelectedRowUuid}
            handleDeleteRow={handleBulkDelete}
            checkboxSelection={true}
            selectedRowIds={selectedDetailRowIds}
            onRowSelectionChange={setSelectedDetailRowIds}
            columns={columns}
          />
        }
        bottomBar={
          <div className='px-4 py-1'>
            <Button onClick={onClose} variant='outline'>
              <AritoIcon icon={885} marginX='4px' />
              Huỷ
            </Button>
          </div>
        }
      />
    </AritoDialog>
  );
};

export default BulkDeleteDialogV2;
